export default "__VITE_ASSET__9nBIGm0p__"